/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statschatkindslabel3Inputs */

const en_statschatkindslabel3 = /** @type {(inputs: Statschatkindslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split by kind of chat`)
};

const de_statschatkindslabel3 = /** @type {(inputs: Statschatkindslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufteilung nach Art des Chats`)
};

/**
* | output |
* | --- |
* | "Split by kind of chat" |
*
* @param {Statschatkindslabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statschatkindslabel3 = /** @type {((inputs?: Statschatkindslabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statschatkindslabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statschatkindslabel3(inputs)
	return de_statschatkindslabel3(inputs)
});
export { statschatkindslabel3 as "statsChatKindsLabel" }